'use strict';

var __chunk_2 = require('./chunk-d7703e54.js');

var slice = Array.prototype.slice;
/**
 * Converts a function to a variadic function.
 *
 * The last named parameter will be given an array of arguments.
 *
 * @param {Function} f The function.
 * @returns {Function} A function that wraps the function `f` to accept any
 * number of arguments.
 * @example
 *
 * import { variadic } from 'fkit'
 * function f (head, tail) { ... }
 * variadic(f)(1, 2, 3) // f(1, [2, 3])
 */

function variadic(f) {
  var _this = this;

  var arity = f.length;

  if (arity < 1) {
    return f;
  } else if (arity === 1) {
    return function () {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      var newArgs = args.length === 1 ? __chunk_2.flatten(args) : args;
      return f.call(_this, newArgs);
    };
  } else {
    return function () {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      var numMissingArgs = Math.max(arity - args.length - 1, 0);
      var missingArgs = new Array(numMissingArgs);
      var namedArgs = slice.call(args, 0, arity - 1);
      var variadicArgs = slice.call(args, f.length - 1);
      return f.apply(_this, namedArgs.concat(missingArgs).concat([variadicArgs]));
    };
  }
}

module.exports = variadic;
